export default "__VITE_ASSET__DDO1uO19__"